import { Shark, View } from "shark-mvc";

import templateContent from "./profile.html";

import mainNavComponent from "../../components/main-nav/mainNavComponent";
import projectListView from "../project/projectListView";
import userManager from "../../controllers/userManager";
import waitBoxComponent from "../../components/wait-box/waitBoxComponent";

class ProfileView extends View {
	constructor () {
		super("profileView");
		this.setTemplate(templateContent);
	}

	init () {
		this.addComponents([mainNavComponent, waitBoxComponent]);
	}

	saveUserBtn_clickHandler () {
		const { loggedUser } = Shark.get();

		if (loggedUser) {
			const errors = loggedUser.validate("update");
			console.log({errors});

			if (errors.length > 0) {
				// alert(errors.join("\n"));
				Shark.render();
				return;
			}
			
			waitBoxComponent.open();
			userManager.save(loggedUser)
			.then(() => {
				waitBoxComponent.close();
				Shark.openPage(projectListView);
			});
		}
	}
}

const profileView = new ProfileView();

Shark.registerView(profileView);

export default profileView;
